<template>
  <v-breadcrumbs v-if="breadcrumbs.length > 0" class="pa-0 mb-2 pt-2" :items="breadcrumbs">
    <template #item="{ item }">
      <v-breadcrumbs-item :text="item.text" :to="item.to" :exact="item.exact">
        <span class="overflow">
          {{ item.text }}
        </span>
      </v-breadcrumbs-item>
    </template>

    <template #divider>
      <v-icon>chevron_right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import { useGetProjectQuery } from '@/api/useProjectsQueries'
import { computed } from 'vue'

const props = defineProps<{
  projectId: string
  jobDisplayName: string
  route: string
}>()

const { data: project, isLoading } = useGetProjectQuery(
  computed(() => props.projectId),
  { enabled: computed(() => !!props.projectId) },
)

const breadcrumbs = computed(() => {
  if (isLoading.value || !project.value) return []

  if (project.value.id === undefined) return []

  return [
    {
      text: project.value?.displayName,
      exact: true,
      to: {
        name: props.route,
        params: { projectId: props.projectId },
      },
    },
    {
      text: props.jobDisplayName,
    },
  ]
})
</script>

<style scoped>
.overflow {
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
